<div class="w-[30rem]" *transloco="let t">
  <div class="mb-5 text-sm text-gray-500">
    Current name: <span class="font-semibold">{{ data.initialValue }}</span>
  </div>
  <IInput [(value)]="value" type="text" size="sm" [maxLength]="data.maxLength ?? 200" autoFocus />

  <div class="mt-4 flex justify-end gap-2" *transloco="let t">
    <IButton label="{{ t('common.cancel') }}" color="white" (onClick)="ref.close()" size="sm" />
    <IButton
      class="w-2/4"
      label="{{ t('common.save') }}"
      type="submit"
      (onClick)="update()"
      [block]="true"
      size="sm"
      [disabled]="value.length === 0"
    />
  </div>
</div>
